<template>
  <van-popup v-model="show" get-container="#app" round @click-overlay="closePop">
    <div class="pop-outer">
      <div class="pop-header">
        <span style="margin-right: .3005rem;"></span>{{ findDate }}
        请假处理
        <div class="close-btn" @click="closePop">
          <van-icon name="cross" />
        </div>
      </div>
      <div class="dispose-form">
        <div class="dispose-form-item">
          <div class="form-label" style="align-items: center;">
            <span>请假类型：</span>
          </div>
          <div class="form-content">
            <div @click="leaveType = 0"
              :class="leaveType === 0 ? 'form-content_type form-content_type_active' : 'form-content_type'">请假离校
            </div>
            <div @click="leaveType = 1"
              :class="leaveType === 1 ? 'form-content_type form-content_type_active' : 'form-content_type'">请假在寝</div>
          </div>
        </div>
        <div class="dispose-form-item">
          <div class="form-label" style="align-items: center;">
            开始时间：
          </div>
          <div class="form-content" @click="openDatePicker(1)">
            <div class="form-content_input">
              {{ batchLeaveDateInfo.startDate ? getDate(batchLeaveDateInfo.startDate) : '' }}
              {{ batchLeaveDateInfo.startTime ?
    batchLeaveDateInfo.startDateType == 1 && batchLeaveDateInfo.startTimeType ? batchLeaveDateInfo.startTime +
      ' ' + ['', '早离寝', '午归寝', '午离寝', '晚归寝'][batchLeaveDateInfo.startTimeType] +
      `${batchLeaveDateInfo.startSelectTimeType == 'start' ? '开始' : '结束'}` : batchLeaveDateInfo.startTime : '' }}
            </div>
          </div>
        </div>
        <div class="dispose-form-item">
          <div class="form-label" style="align-items: center;">
            结束时间：
          </div>
          <div class="form-content" @click="openDatePicker(2)">
            <div class="form-content_input">
              {{ batchLeaveDateInfo.endDate ? getDate(batchLeaveDateInfo.endDate) : '' }}
              {{ batchLeaveDateInfo.endTime ? batchLeaveDateInfo.endDateType == 1 && batchLeaveDateInfo.endTimeType ?
    batchLeaveDateInfo.endTime + ' ' + ['', '早离寝', '午归寝', '午离寝', '晚归寝'][batchLeaveDateInfo.endTimeType] +
    `${batchLeaveDateInfo.endSelectTimeType == 'start' ? '开始' : '结束'}` : batchLeaveDateInfo.endTime : '' }}
            </div>
          </div>
        </div>
        <div class="dispose-form-item">
          <div class="form-label" style="align-items: center;">
            请假事项：
          </div>
          <div class="form-content" @click="openPicker">
            <div class="form-content_input">
              {{ leaveMatters }}
            </div>
          </div>
        </div>
        <div class="dispose-form-item">
          <div class="form-label" style="padding-top: .3606rem;">
            请假原因：
          </div>
          <div class="form-content">
            <van-field v-model="reason" rows="1" :autosize="{ minHeight: 100 }" type="textarea"
              class="aj-textarea-input" maxlength="150" />
          </div>
        </div>
      </div>
      <div class="pop-button">
        <div class="pop-button-cancel" @click="closePop">取消</div>
        <div class="pop-button-confirm" @click="batchAddLeave">确定</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import filterRadio from './batchFilterRadio.vue';
import moment from 'moment';
export default {
  components: { filterRadio },
  props: {
    batchLeaveDateInfo: {
      type: Object,
      default: {}
    },
    leaveMatters: {
      type: String,
      default: ''
    },
    // 时段请假或者实时补签
    leaveTimeOrNow: {
      type: Number,
      default: '1'
    },

    filterData: {
      type: Object,
      default: {}
    }


  },
  data() {
    return {
      // 请假原因
      reason: null,
      // 请假类型
      leaveType: 0,
      // 请假类型列表
      columns: ['事假', '病假', '其他'],
      // 请假弹窗选择
      show: false,
      dormOrganId: '',
      // 当前日期
      findDate: '',
      // 选中的所有学生
      personList: [],
      radioList: [{
        showValue: '请假在寝',
        subValue: '0',
      }, {
        showValue: '请假离校',
        subValue: '1',
      }]
    };
  },
  computed: {

  },
  methods: {
    open(data) {
      this.show = true;
      this.personList = data.nowSelectPersonList
      this.findDate = data.findDate
      this.dormOrganId = data.dormOrganId
      console.log('this.batchLeaveDateInfo', this.batchLeaveDateInfo, data)
    },

    // 判断当前展示什么时间 （ 开始 / 结束 ） 


    openPicker() {
      this.$emit('openPicker');
    },
    openDatePicker(type) {
      this.$emit('openLeaveDate', type);
    },

    closePop() {
      this.show = false;
      this.$emit('close');
    },
    // 批量添加请假
    batchAddLeave() {

      let _this = this;
      if (!this.batchLeaveDateInfo.startDate || !this.batchLeaveDateInfo.startTime) { // 监测开始时间选择
        this.$toast({ getContainer: '#app', message: '请选择请假开始时间' })
        return
      }

      if (!this.batchLeaveDateInfo.endDate || !this.batchLeaveDateInfo.endTime) { // 监测结束时间
        this.$toast({ getContainer: '#app', message: '请选择请假结束时间' })
        return
      }

      // 判断请假时间的先后顺序
      if (moment(`${this.batchLeaveDateInfo.endDate} ${this.batchLeaveDateInfo.endTime}`, 'YYYY年MM月DD日 HH:mm').isSame(moment(`${this.batchLeaveDateInfo.startDate} ${this.batchLeaveDateInfo.startTime}`, 'YYYY年MM月DD日 HH:mm'), 'minute')) {

        this.$toast({ getContainer: '#app', message: '结束时间不能和开始时间相同' })
        return
      }

      if (moment(`${this.batchLeaveDateInfo.endDate} ${this.batchLeaveDateInfo.endTime}`, 'YYYY年MM月DD日 HH:mm').isBefore(moment(`${this.batchLeaveDateInfo.startDate} ${this.batchLeaveDateInfo.startTime}`, 'YYYY年MM月DD日 HH:mm'), 'minute')) {

        this.$toast({ getContainer: '#app', message: '结束时间不能在开始时间之前' })

        return
      }

      if (!this.leaveMatters) {
        this.$toast({ getContainer: '#app', message: '请选择请假事项' })
        return
      }


      let promiseAll = [];
      // 请求参数
      let params = {
        auditId: JSON.parse(localStorage.getItem('userInfo')).id,
        eventType: this.leaveType,
        leaveBeginTime: moment(`${this.batchLeaveDateInfo.startDate} ${this.batchLeaveDateInfo.startTime}`, 'YYYY年MM月DD日 HH:mm').format('YYYY-MM-DD HH:mm:ss'),
        leaveEndTime: moment(`${this.batchLeaveDateInfo.endDate} ${this.batchLeaveDateInfo.endTime}`, 'YYYY年MM月DD日 HH:mm').format('YYYY-MM-DD HH:mm:ss'),
        leaveType: this.leaveMatters,
        remark: this.reason,
        schoolId: this.$store.state.schoolId,
        userId: this.$store.state.userId
      }

      if (this.leaveTimeOrNow == 1) {
        // this.personList.forEach(item => {
        //   promiseAll.push(
        //     new Promise((resolve, reject) => {
        //       _this.$https
        //         .teacherAuthLeave({ leaveId: item.userId, ...params })
        //         .then(res => {
        //           resolve(res);
        //         })
        //         .catch(e => {
        //           reject(e);
        //         });
        //     })
        //   );
        // })
        const loading = this.$toast.loading({
          duration: 0,
          message: '请假中',
          forbidClick: true,
          getContainer: '#app'
        });
        // Promise.all(promiseAll).then(res => {
        //   if (res.some(x => x.code != 200)) {
        //     loading.clear();
        //     _this.$toast('请假失败');

        //   } else {
        //     loading.clear();

        //     _this.$toast({
        //       type: 'success',
        //       overlay: true,
        //       message: '成功',
        //       duration: 1500
        //     });
        //     setTimeout(() => {
        //       this.show = false
        //       this.$emit('confirm', 'refresh')
        //     }, 2000);
        //     _this.btn_loading = false;
        //   }
        // })




        // 批量请假接口
        let leaveIds = this.personList.map(item => item.userId)
        this.$https.teacherAuthLeaveBatch({
          ...params,
          leaveIds: leaveIds
        }).then(res => {
          if (res.code == 200) {
            loading.clear();

            _this.$toast({
              type: 'success',
              overlay: true,
              message: '成功',
              duration: 1500
            });
            setTimeout(() => {
              this.show = false
              this.$emit('confirm', 'refresh')
            }, 2000);
            _this.btn_loading = false;
          } else {
            loading.clear();
            _this.$toast('请假失败');
          }
        })
        


      } else if (this.leaveTimeOrNow == 2) {
        let userArr = this.personList.map(item => item.userId)
        const loading = this.$toast.loading({
          duration: 0,
          message: '请假中',
          forbidClick: true,
          getContainer: '#app'
        });
        this.$https.dormSignInByLeave({
          ...params,
          leaveIds: userArr,
          // timeType: this.filterData.timeType[0],
          dormId: this.dormOrganId,
          signDate: this.filterData.date,
        }).then(res => {
          if (res.code == 200) {
            loading.clear();

            _this.$toast({
              type: 'success',
              overlay: true,
              message: '成功',
              duration: 1500
            });
            setTimeout(() => {
              this.show = false
              this.$emit('confirm', 'refresh')
            }, 2000);
            _this.btn_loading = false;
          } else {
            loading.clear();
            _this.$toast('请假失败');
          }
        })
      }
    },


    // 转换时间格式
    getDate(date) {
      return moment(date, 'YYYY年MM月DD日').format('YY-MM-DD')
    }
  }
};
</script>

<style lang="scss" scoped>
@import url('./loading.scss');

.pop-outer {
  color: #333;
  padding: 0 1.5rem;
  padding-bottom: 2rem;
  width: 90vw;
  position: relative;
  font-size: 0.875rem;
  background: url('./popinfo-bg.png');
  background-size: 100% 100%;

  .pop-header {
    padding: 1rem 0 1.125rem 0;
    text-align: center;
    position: relative;
    font-size: 1rem;
    font-weight: bold;

    .close-btn {
      position: absolute;
      color: #999999;
      right: -0.5rem;
      top: 1rem;
      font-size: 1rem;
    }
  }

  .pop-button {
    margin-top: 1rem;
    display: flex;
    justify-content: space-around;

    &>div {
      padding: 0.5rem 2rem;
      border-radius: 2rem;
    }

    .pop-button-cancel {
      background-color: #e0e8f6;
    }

    .pop-button-confirm {
      background-color: #1989fa;
      color: #fff;
    }
  }
}

.dispose-form-item {
  display: flex;

  &+& {
    margin-top: .875rem;
  }

  .form-label {
    text-align: right;
    display: flex;
    padding-right: 0.5rem;
    padding-top: 0.1rem;
    color: #666666ff;
  }

  .form-content {
    flex: 1;
    display: flex;
    align-items: center;

    // 请假类型
    .form-content_type {
      height: 1.875rem;
      line-height: 1.875rem;
      padding: 0 1.0625rem;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: .875rem;
      color: #666666;
      border-radius: .9375rem;
      background: #F4F5F9;
      margin-right: .4375rem;
    }

    .form-content_type_active {
      color: #fff;
      background: #3775FF;
    }

    .form-content_input {
      flex: 1;
      height: 2.25rem;
      border-radius: .25rem;
      line-height: 2.25rem;
      padding: 0 .625rem;
      background-color: #F4F5F9;

      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: .875rem;
      color: #333333;
      text-align: left;
    }

  }
}

::v-deep.aj-radio-circle {

  // background-color: red;
  .van-radio {
    margin-bottom: 0.5rem;

    .van-radio__icon {
      display: flex;
      align-items: center;

      .van-icon {
        background-color: #fff;
        height: 0.8em;
        width: 0.8em;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .van-radio__icon.van-radio__icon--checked {
      .van-icon {
        &::before {
          display: none;
        }

        &::after {
          display: block;
          content: '';
          width: 50%;
          height: 50%;
          background-color: #1989fa;
          border-radius: 100%;
        }
      }
    }
  }
}

::v-deep.aj-textarea-input {

  &.van-cell {
    padding: 0.25rem 0.5rem;
    background-color: #F4F5F9;
  }
}
</style>
